class NadheoPlaceSeats {
  // Arrays of seat reference
  placeSeats = [];
  performanceSeats = [];
  refreshTime = undefined;
  performanceFreeSeats = [];
  performanceBookedSeats = [];
  performancePaidSeats= [];
  performanceNotForSaleSeats = [];
  performanceBufferedSeats = [];
  highlightedSeats =[];
  isolatedSeats = [];
  isolatedSeatsToBeRefreshed = true;

  //Array of Arrays of seat reference
  placeSeatRows = [];

  //Array of Seat categories
  seatCategories = [];
  
  /**
  * Creation of the object with initial state: 
  * - the place seats (array of {group.name: xxx, name: xxx})
  * - the place seat rows (array of (array of {group.name: xxx, name: xxx}))
  * - the current performance seat state (array of {group.name: xxx, name: xxx, status: free|paid|booked})
  */
  constructor(pSeats, pSeatRows, performanceSeats, refreshTime)
  {
    this.placeSeats = pSeats;
    this.placeSeatRows = pSeatRows;
    this.performanceSeats = performanceSeats;
    this.refreshTime = refreshTime;
    this.handlePerformanceSeats(performanceSeats);
  }

  addSeatCategory(category)
  {
    if (!this.seatCategories.includes(category))
      this.seatCategories.push(category);
  }

  handlePerformanceSeats(performanceSeats)
  {
    this.performanceNotForSaleSeats = Array.from(this.placeSeats);
    for (let perfSeat of performanceSeats)
    {
      //console.log(JSON.stringify(perfSeat));
      this.addSeatCategory(perfSeat["seat.category"]);
      let seat = {"group.name": perfSeat["group.name"], "name": perfSeat["name"], "category": perfSeat["seat.category"]};
      if (perfSeat.status === "free")
        this.performanceFreeSeats.push(seat);
      if (perfSeat.status === "paid")
        this.performancePaidSeats.push(seat);
      if (perfSeat.status === "booked")
        this.performanceBookedSeats.push(seat);
      if (perfSeat.status === "buffered")
        this.performanceBufferedSeats.push(seat);
      
      let index = this.performanceNotForSaleSeats.findIndex(
          (item) => (item["group.name"] === seat["group.name"] && item.name === seat.name));
      this.performanceNotForSaleSeats.splice(index, 1);
    }
  }

  existsSeat(status)
  {
    if (status === "free") return this.performanceFreeSeats.length > 0;
    if (status === "paid") return this.performancePaidSeats.length > 0;
    if (status === "booked") return this.performanceBookedSeats.length > 0;
    if (status === "buffered") return this.performanceBufferedSeats.length > 0;
    return false;
  }

  setHighlightedSeats(hSeats)
  {
    if (hSeats === undefined) throw new Error("Illegal argument");
    this.highlightedSeats = [];
    for (const seat of hSeats) {
      //Retrieve the seat so that we get the seat category
      let perfSeat = this.performanceFreeSeats.find(s=>(s["group.name"]===seat["group.name"] && s.name===seat.name));
      if (perfSeat === undefined)
        perfSeat = this.performancePaidSeats.find(s=>(s["group.name"]===seat["group.name"] && s.name===seat.name));
      if (perfSeat === undefined)
        perfSeat = this.performanceBookedSeats.find(s=>(s["group.name"]===seat["group.name"] && s.name===seat.name));
      if (perfSeat === undefined)
        perfSeat = this.performanceNotForSaleSeats.find(s=>(s["group.name"]===seat["group.name"] && s.name===seat.name));
      if (perfSeat === undefined)
        perfSeat = this.performanceBufferedSeats.find(s=>(s["group.name"]===seat["group.name"] && s.name===seat.name));
      if (perfSeat === undefined) throw new Error("Seat cannot be found "+ JSON.stringify(seat));
      this.highlightedSeats.push(perfSeat);
    }
    this.isolatedSeatsToBeRefreshed = true;
  }

  updatePerformanceSeats(performanceSeats)
  {
    for (let perfSeat of performanceSeats)
    {
      let seat = {"group.name": perfSeat.seat["seat.group.name"],
                  "name": perfSeat.seat["seat.name"],
                  "category": perfSeat.seat["seat.category"]};
      this.addSeatCategory(perfSeat.seat["seat.category"]);
      this.removeSeatFromPerformanceSeats(seat);

      if (perfSeat.seat.status === "free") this.performanceFreeSeats.push(seat);
      if (perfSeat.seat.status === "paid") this.performancePaidSeats.push(seat);
      if (perfSeat.seat.status === "booked") this.performanceBookedSeats.push(seat);
      if (perfSeat.seat.status === "buffered") this.performanceBufferedSeats.push(seat);
    }
    if (performanceSeats !== undefined || performanceSeats.length > 0)
      this.isolatedSeatsToBeRefreshed = true;
  }

  removeSeatFromPerformanceSeats(seat)
  {
    // Remove the seat from the performance seats
    let idx = this.performanceFreeSeats.findIndex((item)=>this.areSeatsEqual(item, seat));
    if (idx >= 0) this.performanceFreeSeats.splice(idx, 1);
    idx = this.performancePaidSeats.findIndex((item)=>this.areSeatsEqual(item, seat));
    if (idx >= 0) this.performancePaidSeats.splice(idx, 1);
    idx = this.performanceBookedSeats.findIndex((item)=>this.areSeatsEqual(item, seat));
    if (idx >= 0) this.performanceBookedSeats.splice(idx, 1);
  }

  setHighlighted(groupName, name)
  {
    if (this.getSeatStatus(groupName, name) === "highlighted") return;
    let seat = {"group.name": groupName, "name": name, "category": this.getSeatCategory(groupName, name)};
    this.removeSeatFromPerformanceSeats(seat);
    this.highlightedSeats.push(seat);
    this.isolatedSeatsToBeRefreshed = true;
  }

  setFree(groupName, name)
  {
    if (this.getSeatStatus(groupName, name) === "free") return;
    let seat = {"group.name": groupName, "name": name, "category": this.getSeatCategory(groupName, name)};
    this.removeSeatFromPerformanceSeats(seat);
    let idx = this.highlightedSeats.findIndex((item)=>this.areSeatsEqual(item, seat));
    if (idx >= 0) this.highlightedSeats.splice(idx, 1);
    this.performanceFreeSeats.push(seat);
    this.isolatedSeatsToBeRefreshed = true;
  }
  getSeatStatus(groupName, name)
  {
    if (this.isolatedSeatsToBeRefreshed) this.refreshIsolatedSeats();
    if (this.isolatedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "isolated";
    if (this.highlightedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "highlighted";
    if (this.performanceNotForSaleSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "notforsale";
   if (this.performanceFreeSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "free";
    if (this.performanceBookedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "booked";
    if (this.performancePaidSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "paid";
    if (this.performanceBufferedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined)
      return "buffered";
    return "unknown";
  }
  isFree(groupName, name) {
    if (this.isolatedSeatsToBeRefreshed) this.refreshIsolatedSeats();
    return this.isolatedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined ||
      this.highlightedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined ||
      this.performanceFreeSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined;
  }
  isHightlighted(groupName, name) {
    return (this.highlightedSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name)) !== undefined);
  }
  getSeatCategory(groupName, name)
  {
    const s = this.performanceSeats.find((seat)=>(seat["group.name"] === groupName && seat.name === name))
    if (s === undefined) {
      console.log("ERROR: seat does not exist for the performance: " + groupName + " " + name);
      console.log("Performance Seats: ");
      console.log(JSON.stringify(this.performanceSeats));
    }
    return s["seat.category"];
  }
 
  refreshIsolatedSeats()
  {
    // Group highlighted seats in segments
    let highlightedRowSegments = this.getSeatRowSegments(); 
    // Check isolated seats between highlighted seats segments
    let result = this.getIsolatedSeatBetweenHighlightedRowSegments(highlightedRowSegments);
    // Check isolated seats at the border of highlighted seats segments
    result = result.concat(this.getIsolatedSeatsAtTheBorder(highlightedRowSegments));
    this.isolatedSeats = result;
    this.isolatedSeatsToBeRefreshed = false;
  }


  /**
   * Order the highlighted seats in contiguous segment of seats from the seatRows
   * Return (array of (array of {group.name: xxx, name: xxx}))
   */
  getSeatRowSegments()
  {
    if (this.highlightedSeats === undefined || this.highlightedSeats.length === 0) return [];
    let result = [];
    let seatsToBeSorted = this.highlightedSeats.concat([]);
    while (seatsToBeSorted.length > 0)
    {
      let seat = seatsToBeSorted[0];
      // Sort the first element of toBeSorted
      let seatRow = this.getSeatRowIndex(seat);
      if (seatRow >= 0)
      {
        let seatIndex = this.placeSeatRows[seatRow].seats.findIndex((item)=>(this.areSeatsEqual(item, seat)));
        // Find the lower index of the seat segment
        let lowerBound = seatIndex;
        let found = !(lowerBound > 0); // If the seat is the first of the row, we found the segment lower bound
        while (!found)
        {
          let previous = this.placeSeatRows[seatRow].seats[lowerBound - 1];
          if (this.highlightedSeats.find((seat)=>(seat["group.name"] === previous["group.name"] && seat.name === previous.name)) !== undefined)
          {
            lowerBound--;
            found = !(lowerBound > 0);
          } else
          {
            found = true;
          }
        }
        // Construct the current segment and remove the segment seats from seatToBeSorted
        let segment = [];
        let currentIndex = lowerBound;
        let done = false;
        while (!done)
        {
          let currentSeat = this.placeSeatRows[seatRow].seats[currentIndex];
          if (this.highlightedSeats.find((seat)=>(seat["group.name"] === currentSeat["group.name"] && seat.name === currentSeat.name)) !== undefined)
          {
            segment.push(currentSeat);
            seatsToBeSorted.splice(seatsToBeSorted.findIndex((item)=>(this.areSeatsEqual(item, currentSeat))), 1);
            currentIndex++;
            done = (currentIndex >= this.placeSeatRows[seatRow].seats.length);
          } else
          {
            done = true;
          }
        }
        result.push(segment);
      } else
      {
        seatsToBeSorted.splice(seatsToBeSorted.findIndex((item)=>(this.areSeatsEqual(item, seat))), 1);
      }
    }
    return result;
  }

  /**
   * Retrieve the row containing the specific seat
   */
  getSeatRowIndex(s)
  {
    let result = 0;
    for (let seatRow of this.placeSeatRows)
    {
      if (seatRow.seats.findIndex((seat)=>(this.areSeatsEqual(seat, s))) >= 0)
        return result;
      result++;
    }
    return -1;
  }

  getIsolatedSeatBetweenHighlightedRowSegments(highlightedRowSegments)
  {
    if (highlightedRowSegments.length === 0) return []; // Important as new Array([]) returns an empty Array of length 1 !!
    let result = [];
    let segmentsCopy = [].concat(highlightedRowSegments);
    while (segmentsCopy.length > 0)
    {
      let currentSegment = segmentsCopy[0];
      let firstSeat = currentSegment[0];
      let lastSeat = currentSegment[currentSegment.length - 1];
      let currentSegmentRowIndex = this.getSeatRowIndex(firstSeat);
      let currentSegmentRow = this.placeSeatRows[currentSegmentRowIndex];
      let firstSeatIndexInRow = currentSegmentRow.seats.findIndex((seat)=>(this.areSeatsEqual(seat, firstSeat)));
      let lastSeatIndexInRow = currentSegmentRow.seats.findIndex((seat)=>(this.areSeatsEqual(seat, lastSeat)));
      if (!this.areSeatsEqual(currentSegmentRow.seats[0], firstSeat) &&   // The segment is at the row border
          !this.areSeatsEqual(currentSegmentRow.seats[currentSegmentRow.lendth-1], lastSeat) &&
          // The segment is adjacent to non free seats
          this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, currentSegmentRow.seats[firstSeatIndexInRow - 1]))) !== undefined &&
          this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, currentSegmentRow.seats[lastSeatIndexInRow + 1]))) !== undefined)
      {
        for (let i = 1; i < segmentsCopy.length; i++)
        {
          let otherSegment = segmentsCopy[i];
          let firstSeatOfOtherSegment = otherSegment[0];
          let lastSeatOfOtherSegment = otherSegment[otherSegment.length - 1];
          let otherSegmentRowIndex = this.getSeatRowIndex(firstSeatOfOtherSegment);
          if (currentSegmentRowIndex === otherSegmentRowIndex)
          {
            let betweenSegment = this.getSegmentBetweenSeats(currentSegmentRow,
                    lastSeatOfOtherSegment, currentSegment[0]);
            if (betweenSegment.length === 1)
            {
              if (this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, betweenSegment[0]))) !== undefined)
              {
                result = result.concat(betweenSegment[0]);
              }
            }
            betweenSegment = this.getSegmentBetweenSeats(currentSegmentRow,
                    currentSegment[currentSegment.length-1], firstSeatOfOtherSegment);
            if (betweenSegment.length === 1)
            {
              if (this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, betweenSegment[0]))) !== undefined)
              {
                result = result.concat(betweenSegment[0]);
              }
            }
          }
        }
      }
      segmentsCopy.splice(0, 1);
    }  
    return result;
  }

  getSegmentBetweenSeats(seatRow, firstSeat, secondSeat)
  {
    let result = [];
    let addToResult = false;
    for (let seat of seatRow.seats)
    {
      // Second seat is reached ? We are done
      if (this.areSeatsEqual(seat, secondSeat)) return result;
      if (addToResult)
      {
        result.push(seat);
      } else
      {
        if (this.areSeatsEqual(seat, firstSeat)) addToResult = true;
      }
    }
    // If the second seat is not in the row, return empty segment.
    return [];
  }

  areSeatsEqual(seat1, seat2)
  {
    if (seat1 === undefined || seat2 === undefined) return false;
    if (seat1["group.name"] === undefined || seat1.name === undefined || 
        seat2["group.name"] === undefined || seat2.name === undefined) return false;
    return (seat1["group.name"] === seat2["group.name"] && seat1.name === seat2.name);
  }

  getIsolatedSeatsAtTheBorder(rowSegments)
  {
    if (rowSegments === undefined || rowSegments.length === 0) return [];
    let result = [];
    for (let segment of rowSegments)
    {
      let row = this.placeSeatRows[this.getSeatRowIndex(segment[0])];
      // Does the row segment contain a seat at the border of the row ?
      // Yes -> no problem
      if (!this.isSegmentAtRowBorder(segment, row))
      {
        // Are both adjacent seats of the segment free ?
        // No -> no problem
        let segmentLowerIndexInRow = row.seats.findIndex((seat)=>(this.areSeatsEqual(seat, segment[0])));
        let segmentHigherIndexInRow = row.seats.findIndex((seat)=>(this.areSeatsEqual(seat, segment[segment.length-1])));
        if (this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, row.seats[segmentLowerIndexInRow - 1]))) !== undefined &&
            this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, row.seats[segmentHigherIndexInRow + 1]))) !== undefined)
        {
          // For each of the free adjacent seat of the segment, is the next adjacent seat free ?
          // Yes -> no problem
          if (segmentLowerIndexInRow - 2 < 0 ||
                  this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, row.seats[segmentLowerIndexInRow - 2]))) === undefined)
          {
            result.push(row.seats[segmentLowerIndexInRow - 1]);
          } else
          {
            if (segmentHigherIndexInRow + 2 > row.length-1 ||
                    this.performanceFreeSeats.find((seat)=>(this.areSeatsEqual(seat, row.seats[segmentHigherIndexInRow + 2]))) === undefined)
            {
              result.push(row.seats[segmentHigherIndexInRow + 1]);
            }
          }
        }
      }
    }
    return result;
  }

  isSegmentAtRowBorder(segment, row)
  {
      if (this.areSeatsEqual(row[0], segment[0])) return true;
      if (this.areSeatsEqual(row[row.length-1], segment[segment.length-1])) return true;
      return false;

  }
}
export default NadheoPlaceSeats;
